import React, {useState} from 'react';
import styles from './like.module.scss';
import {like} from "@/actions/post";
import {useDispatch} from "react-redux";

type Props = {
    post: IPostDetails | IPostItem
}

const Like: React.FC<Props> = ({ post }) => {
    const [liked, setLiked] = useState<boolean>(post.likedByViewer || false);
    const dispatch = useDispatch();

    const postLikeChange = (newState: boolean) => {
        like(post.id, newState)(dispatch).then(() => {
            setLiked(newState);
        });
    }

  return (
      <span className={styles.like} onClick={() => postLikeChange(!liked)}>
        {liked ? (
            <i className={"fas fa-heart " + styles.liked} />
        ) : (
            <i className="far fa-heart" />
        )}
      </span>
  );
}

export default Like;
